import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/sub-category-list-show`);
      const dataWithIndex = res.data.map((item, index) => ({
        ...item,
        index: index + 1, // Add index field
      }));
      setReceiveData(dataWithIndex);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const cols = [
    { field: "index", header: "S/N", accessor: (item) => item.index },
    {
      field: "coa_name",
      header: "COA Name",
      accessor: (item) => item.coa_name,
    },
    {
      field: "coa_code",
      header: "COA Code",
      accessor: (item) => item.coa_code,
    },
    {
      field: "details",
      header: "Details",
      accessor: (item) => "",
      subHeader: true,
    },
    {
      field: "opening_balance",
      header: "Opening Balance",
      accessor: (item) => item.detail.map((info) => info.opening_balance),
    },
    {
      field: "total_debit",
      header: "Total Debit",
      accessor: (item) => item.detail.map((info) => info.total_debit),
    },
    {
      field: "total_credit",
      header: "Total Credit",
      accessor: (item) => item.detail.map((info) => info.total_credit),
    },
    {
      field: "balance",
      header: "Balance",
      accessor: (item) => item.detail.map((info) => info.balance),
    },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Sub Category</h5>
            <Link to="/create-sub-category" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>New
            </Link>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const actionTemplate = (info, deleteData) => {
  return (
    <td className="text-xs">
      <Link
        to={{
          pathname: "/edit-sub-category/" + info.id,
        }}
        className="btn btn-primary btn-sm"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link>{" "}
      &nbsp;
      <Link
        to={{
          pathname: "/sub-category-ledger/" + info.id,
        }}
        className="btn btn-info btn-sm"
      >
        <i className="fa fa-list" aria-hidden="true"></i>
      </Link>
    </td>
  );
};

export default List;
